
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import DocsLayout from '../../components/DocsLayout'
import NextPage from '../../components/NextPage'
import Motivation from '../../sections/basics/motivation.md'
import GettingStarted from '../../sections/basics/getting-started.md'
import ComingFromCSS from '../../sections/basics/coming-from-css.md'
import Installation from '../../sections/basics/installation.md'
import PassedProps from '../../sections/basics/passed-props.md'
import AdaptingBasedOnProps from '../../sections/basics/adapting-based-on-props.md'
import StylingAnyComponents from '../../sections/basics/styling-any-component.md'
import ExtendingStyles from '../../sections/basics/extending-styles.md'
import AttachingAdditionalProps from '../../sections/basics/attaching-additional-props.md'
import Animations from '../../sections/basics/animations.md'
import ReactNative from '../../sections/basics/react-native.md'


const layoutProps = {
  
};
const MDXLayout = ({ children }) => (
  <DocsLayout title="Basics" description="Get Started with styled-components basics.">
    {children}
  </DocsLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Motivation mdxType="Motivation" />
    <Installation mdxType="Installation" />
    <GettingStarted mdxType="GettingStarted" />
    <AdaptingBasedOnProps mdxType="AdaptingBasedOnProps" />
    <ExtendingStyles mdxType="ExtendingStyles" />
    <StylingAnyComponents mdxType="StylingAnyComponents" />
    <PassedProps mdxType="PassedProps" />
    <ComingFromCSS mdxType="ComingFromCSS" />
    <AttachingAdditionalProps mdxType="AttachingAdditionalProps" />
    <Animations mdxType="Animations" />
    <ReactNative mdxType="ReactNative" />
    <NextPage href="/docs/advanced" title="Advanced" mdxType="NextPage" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;